/**
 * Logging utility that only logs in development mode
 * In production, these calls will be no-ops
 */

const isDevelopment = process.env.NODE_ENV === 'development'

/* eslint-disable no-console */
export const logger = {
  log: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.log(...args)
    }
  },

  error: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.error(...args)
    }
  },

  warn: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.warn(...args)
    }
  },

  info: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.info(...args)
    }
  },

  debug: (...args: unknown[]): void => {
    if (isDevelopment) {
      console.debug(...args)
    }
  }
}

// For critical errors that should always be logged regardless of environment
export const criticalLogger = {
  error: (...args: unknown[]): void => {
    console.error(...args)
  }
}
/* eslint-enable no-console */
